export default __webpack_public_path__ + "static/media/broadcast-segment.c0d35b04.svg";